<template>
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M20.4096 2.20312H1.59036C0.859591 2.20312 0.265076 2.79764 0.265076 3.52841V20.7573C0.265076 21.4881 0.859591 22.0827 1.59036 22.0827H20.4096C21.1404 22.0827 21.7349 21.4881 21.7349 20.7574V3.52845C21.7349 2.79768 21.1404 2.20312 20.4096 2.20312ZM20.1446 20.4923H1.85544V3.79348H20.1446V20.4923H20.1446Z" class="icon-fill"/>
      <path d="M20.9398 7.50488H1.06024V9.09524H20.9398V7.50488Z" class="icon-fill"/>
      <path d="M5.83131 0.0830078C5.39213 0.0830078 5.03613 0.439004 5.03613 0.878188V5.11916C5.03613 5.55834 5.39213 5.91434 5.83131 5.91434C6.2705 5.91434 6.62649 5.55834 6.62649 5.11916V0.878188C6.62649 0.439004 6.2705 0.0830078 5.83131 0.0830078Z" class="icon-fill"/>
      <path d="M16.4337 0.0830078C15.9945 0.0830078 15.6385 0.439004 15.6385 0.878188V5.11916C15.6385 5.55834 15.9945 5.91434 16.4337 5.91434C16.8729 5.91434 17.2289 5.55834 17.2289 5.11916V0.878188C17.2289 0.439004 16.8729 0.0830078 16.4337 0.0830078Z" class="icon-fill"/>
      <path d="M14.0482 15.9863H8.21687C7.77769 15.9863 7.42169 16.3423 7.42169 16.7815C7.42169 17.2207 7.77769 17.5767 8.21687 17.5767H14.0482C14.4874 17.5767 14.8434 17.2207 14.8434 16.7815C14.8434 16.3423 14.4874 15.9863 14.0482 15.9863Z" class="icon-fill"/>
      <path d="M14.0482 12.2754H8.21687C7.77769 12.2754 7.42169 12.6314 7.42169 13.0706C7.42169 13.5098 7.77769 13.8657 8.21687 13.8657H14.0482C14.4874 13.8657 14.8434 13.5098 14.8434 13.0706C14.8434 12.6313 14.4874 12.2754 14.0482 12.2754Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="22" fill="white" transform="translate(0 0.0830078)"/>
      </clipPath>
    </defs>
  </svg>


</template>

<script>
export default {
  name: 'calendar'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>